import { memo } from 'react'
import { Handle, Position, type NodeProps } from '@xyflow/react'
import { ChevronRight, ChevronDown } from 'lucide-react'

interface MindMapGroupNodeData {
  label: string
  docCount: number
  completedCount: number
  conceptCount: number
  expanded: boolean
  groupId: string
  dimmed: boolean
  [key: string]: unknown
}

function MindMapGroupNodeComponent({ data }: NodeProps) {
  const d = data as MindMapGroupNodeData

  return (
    <>
      <Handle type="target" position={Position.Left} className="!w-0 !h-0 !border-0 !bg-transparent" />
      <div
        className={`px-4 py-3 rounded-xl border-2 cursor-pointer transition-all select-none
          ${d.expanded
            ? 'border-purple-500 bg-purple-50 dark:bg-purple-950/40 shadow-lg shadow-purple-500/10'
            : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-purple-400 dark:hover:border-purple-500'
          }
          ${d.dimmed ? 'opacity-20' : 'opacity-100'}
        `}
      >
        <div className="flex items-center gap-2">
          {d.expanded
            ? <ChevronDown className="w-4 h-4 text-purple-500 flex-shrink-0" />
            : <ChevronRight className="w-4 h-4 text-gray-400 dark:text-gray-500 flex-shrink-0" />
          }
          <span className="font-semibold text-sm text-gray-900 dark:text-white">{d.label}</span>
          <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1.5 py-0.5 rounded-full">
            {d.docCount}
          </span>
        </div>
        <div className="flex items-center gap-3 mt-1 ml-6 text-xs text-gray-500 dark:text-gray-400">
          <span>{d.completedCount}/{d.docCount} done</span>
          {d.conceptCount > 0 && <span>{d.conceptCount} concepts</span>}
        </div>
      </div>
      <Handle type="source" position={Position.Right} className="!w-0 !h-0 !border-0 !bg-transparent" />
    </>
  )
}

export const MindMapGroupNode = memo(MindMapGroupNodeComponent)
